module.exports = __webpack_public_path__ + "img/ui_edit.f5c8b059.png";